import {
  SafetyMessageDto,
  SafetyPlanFormFields,
} from '../../../../../types/iapBaseTypes';

export const getEmptySafetyPlanFormValues = (): SafetyPlanFormFields => ({
  safetyOfficer: '',
  dutyPhone: '',
  email: '',
  datetimeInitiated: undefined,
  physicalHazards: [],
  environmentalHazards: [],
  customEnvironmentalHazard: '',
  otherHazards: [],
  customOtherHazard: '',
  otherHazardsText: '',
  safetyMessage: '',
  sopAndSafeWorkPractices: '',
  requiredPpe: [],
  comments: '',
  healthAndSafetyPlan: '',
  healthAndSafetyPlanLocation: '',
});

export const getSafetyPlanFormValuesFromDto = (
  safetyMessage: SafetyMessageDto
): SafetyPlanFormFields => ({
  safetyOfficer: safetyMessage.safetyOfficer || '',
  dutyPhone: safetyMessage.dutyPhone || '',
  email: safetyMessage.email || '',
  datetimeInitiated: safetyMessage.datetimeInitiated
    ? new Date(safetyMessage.datetimeInitiated)
    : undefined,
  physicalHazards: safetyMessage.knownHazards?.physicalHazards || [],
  environmentalHazards: safetyMessage.knownHazards?.environmentalHazards || [],
  customEnvironmentalHazard: '',
  otherHazards: safetyMessage.knownHazards?.otherHazards || [],
  customOtherHazard: '',
  otherHazardsText: safetyMessage.knownHazards?.otherHazardsText || '',
  safetyMessage: safetyMessage.safetyMessage || '',
  sopAndSafeWorkPractices: safetyMessage.sopAndSafeWorkPractices || '',
  requiredPpe: safetyMessage.requiredPpe?.items || [],
  comments: safetyMessage.comments || '',
  healthAndSafetyPlan: safetyMessage.healthAndSafetyInfo?.hasPlan || '',
  healthAndSafetyPlanLocation:
    safetyMessage.healthAndSafetyInfo?.location || '',
});

export const hasSafetyPlanFormData = (
  values: SafetyPlanFormFields
): boolean => {
  return Object.values(values).some((value) => {
    if (Array.isArray(value)) {
      return value.length > 0;
    }
    if (typeof value === 'string') {
      return value.trim().length > 0;
    }
    if (value instanceof Date) {
      return true;
    }
    return false;
  });
};
